import { render } from "./OverallStatisticsView.vue?vue&type=template&id=021ad4ef&scoped=true"
import script from "./OverallStatisticsView.vue?vue&type=script&lang=js"
export * from "./OverallStatisticsView.vue?vue&type=script&lang=js"

import "./OverallStatisticsView.vue?vue&type=style&index=0&id=021ad4ef&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021ad4ef"]])

export default __exports__